import React from 'react';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { Callout } from '@bingads-webui-react/callout';

const renderCalloutSubMenu = (content, item) => (
  <div id={item.popoverId} className={item.popoverClassName} role="menuitem" >
    <h3 className="popover-title">{item.title}</h3>
    <div className="popover-content">
      {content}
      <button
        aria-label={item.closeButtonAriaLabel}
        type="button"
        className="summary-bar-contextual-menu-popover-close-button"
        onClick={item.onClose}
      >
        <Glyphicon glyph="ba-Cancel" />
      </button>
    </div>
  </div>);

export const getOverflowSubMenuProps = (item) => {
  if (item.canEdit && item.Editor === Callout) {
    return {
      subMenuProps: {
        items: [{
          key: `${item.className}-editor`,
          onRender: (_, onDismiss) => {
            const editorProps = item.getEditorProps(true, onDismiss, true, { itemProps: item });

            return renderCalloutSubMenu(editorProps.content, editorProps);
          },
        }],
        calloutProps: {
          preventDismissOnLostFocus: true,
        },
      },
    };
  } else if (item.canEdit) {
    let onClick = null;

    if (item.onClick) {
      // eslint-disable-next-line prefer-destructuring
      onClick = item.onClick;
    } else if (item.getEditorProps) {
      const editorProps = item.getEditorProps(true);

      if (editorProps.shouldNavigate && item.onNavigate) {
        onClick = item.onNavigate;
      }
    }

    return {
      onClick,
    };
  }
  return {};
};
